import { isValidElement, ReactNode } from "react";

export { productJsonLd } from "./productData";

/** Visible text of a React node (links and formatting flattened to plain text). */
export function nodeText(node: ReactNode): string {
  if (node === null || node === undefined || typeof node === "boolean") return "";
  if (typeof node === "string" || typeof node === "number") return String(node);
  if (Array.isArray(node)) return node.map(nodeText).join("");
  if (isValidElement(node)) return nodeText((node.props as { children?: ReactNode }).children);
  return "";
}

/** schema.org FAQPage data built from the same questions shown on the page. */
export function faqJsonLd(items: { question: string; answer: ReactNode }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map(({ question, answer }) => ({
      "@type": "Question",
      name: question,
      acceptedAnswer: { "@type": "Answer", text: nodeText(answer).replace(/\s+/g, " ").trim() },
    })),
  };
}
